import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=57c0140e&"
import script from "./PersonForm.vue?vue&type=script&lang=js&"
export * from "./PersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c0140e')) {
      api.createRecord('57c0140e', component.options)
    } else {
      api.reload('57c0140e', component.options)
    }
    module.hot.accept("./PersonForm.vue?vue&type=template&id=57c0140e&", function () {
      api.rerender('57c0140e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/invoice/components/PersonForm.vue"
export default component.exports